import { Box, Card, CardContent, Tab, Tabs, Typography } from '@mui/material';
import React, { useState } from 'react';

const mcpConfig = `{
  "mcpServers": {
    "nerdydata": {
      "command": "npx",
      "args": ["-y", "@nerdydata/mcp"],
      "env": {
        "NERDYDATA_API_KEY": "your-api-key-here"
      }
    }
  }
}`;

const vsCodeMcpConfig = `{
  "servers": {
    "nerdydata": {
      "command": "npx",
      "args": ["-y", "@nerdydata/mcp"],
      "env": {
        "NERDYDATA_API_KEY": "your-api-key-here"
      }
    }
  }
}`;

const CodeBlock = ({ children }: { children: string }) => (
  <Box
    component="pre"
    sx={{
      backgroundColor: 'grey.100',
      borderRadius: 1,
      p: 2,
      overflowX: 'auto',
      fontSize: '0.85rem',
      fontFamily: 'monospace',
      mt: 1,
      mb: 2,
    }}>
    {children}
  </Box>
);

const ClaudeDesktopTab = () => (
  <>
    <Typography variant="body2" gutterBottom sx={{ mt: 2 }}>
      Open your config file via{' '}
      <strong>Settings → Developer → Edit Config</strong> and add the following,
      replacing <code>your-api-key-here</code> with your API key:
    </Typography>
    <CodeBlock>{mcpConfig}</CodeBlock>
    <Typography variant="body2" color="text.secondary">
      Restart Claude Desktop after saving the file.
    </Typography>
  </>
);

const ClaudeCodeTab = () => (
  <>
    <Typography variant="body2" gutterBottom sx={{ mt: 2 }}>
      Add a <code>.mcp.json</code> file to your project root, replacing{' '}
      <code>your-api-key-here</code> with your API key:
    </Typography>
    <CodeBlock>{mcpConfig}</CodeBlock>
  </>
);

const CursorTab = () => (
  <>
    <Typography variant="body2" gutterBottom sx={{ mt: 2 }}>
      Go to <strong>Settings → Tools & MCP → New MCP Server</strong> to open{' '}
      <code>~/.cursor/mcp.json</code>, then add the following, replacing{' '}
      <code>your-api-key-here</code> with your API key:
    </Typography>
    <CodeBlock>{mcpConfig}</CodeBlock>
  </>
);

const WindsurfTab = () => (
  <>
    <Typography variant="body2" gutterBottom sx={{ mt: 2 }}>
      Open your Windsurf MCP config file and add the following, replacing{' '}
      <code>your-api-key-here</code> with your API key:
    </Typography>
    <CodeBlock>{mcpConfig}</CodeBlock>
  </>
);

const GeminiCliTab = () => (
  <>
    <Typography variant="body2" gutterBottom sx={{ mt: 2 }}>
      Edit <code>~/.gemini/settings.json</code> and add the following, replacing{' '}
      <code>your-api-key-here</code> with your API key:
    </Typography>
    <CodeBlock>{mcpConfig}</CodeBlock>
  </>
);

const VSCodeTab = () => (
  <>
    <Typography variant="body2" gutterBottom sx={{ mt: 2 }}>
      Add a <code>.vscode/mcp.json</code> file to your project root, replacing{' '}
      <code>your-api-key-here</code> with your API key:
    </Typography>
    <CodeBlock>{vsCodeMcpConfig}</CodeBlock>
    <Typography variant="body2" color="text.secondary">
      Note: VS Code uses <code>servers</code> instead of <code>mcpServers</code>{' '}
      in <code>.vscode/mcp.json</code>.
    </Typography>
  </>
);

const tabs = [
  'Claude Desktop',
  'Claude Code',
  'Cursor',
  'Windsurf',
  'Gemini CLI',
  'VS Code',
];

export const McpInstructionsCard = () => {
  const [tab, setTab] = useState(0);

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h5" gutterBottom>
          Setup instructions
        </Typography>
        <Tabs
          value={tab}
          onChange={(_, value: number) => setTab(value)}
          sx={{ borderBottom: 1, borderColor: 'divider' }}>
          {tabs.map((label) => {
            return <Tab key={label} label={label} />;
          })}
        </Tabs>
        {tab === 0 && <ClaudeDesktopTab />}
        {tab === 1 && <ClaudeCodeTab />}
        {tab === 2 && <CursorTab />}
        {tab === 3 && <WindsurfTab />}
        {tab === 4 && <GeminiCliTab />}
        {tab === 5 && <VSCodeTab />}
      </CardContent>
    </Card>
  );
};
